import { useMemo } from 'react';
import {
  CustomizeAssetLayout,
  type CustomizeAssetTab,
} from './CustomizeAssetLayout';
import { SpeakerNotesTab } from './SpeakerNotesTab';

type CustomizeExternalUrlProps = { entityId: string };

export const CustomizeExternalUrl = ({
  entityId,
}: CustomizeExternalUrlProps) => {
  const tabs = useMemo<CustomizeAssetTab[]>(
    () => [
      {
        id: 'speakerNotes',
        label: 'Notes',
        content: (
          <SpeakerNotesTab
            entityId={entityId}
            entityType="externalUrl"
          />
        ),
      },
    ],
    [entityId]
  );

  return <CustomizeAssetLayout tabs={tabs} />;
};
